import CreditAppScriptLoader from './CreditAppScriptLoader';

export default CreditAppScriptLoader;
